export default __webpack_public_path__ + "static/media/abt.6d5b70ba.PNG";